// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1y4Pt","row":"ProcedureTreatmentSummary_row__1KQ0Q"};